import { PDFViewer } from '@react-pdf/renderer';
import ModalOverlay from 'components/shared/ModalOverlay';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import HabitPackPdfDocument from './HabitPdfDocument';
import ModalWrapper from 'components/shared/ModalWrapper';
import Button from 'components/common/buttons/Button';
import CloseCircle from 'assets/icons/CloseCircle';
import COLOR from 'constants/color';
import { updateIsHabitPackPdfShowed } from 'store/reducer/habit-pack/slice';

const HabitPackPdf = () => {
  const dispatch = useAppDispatch();
  const currentViewedPack = useAppSelectorShallow(
    (state) => state.habitPack?.currentViewedPack
  );

  return (
    <ModalOverlay zIndex='z-50'>
      <ModalWrapper>
        <PDFViewer style={{ width: '100%', minHeight: '100%' }}>
          <HabitPackPdfDocument habitPack={currentViewedPack} />
        </PDFViewer>
        <Button
          className='bg-primary-100 rounded-full w-fit absolute top-0.5 right-0.5'
          icon={<CloseCircle fill={COLOR.GRAY['900']} fillDarkMode={COLOR.SEMANTIC.ERROR} />}
          onClick={() => {
            dispatch(updateIsHabitPackPdfShowed(false));
          }}
        />
      </ModalWrapper>
    </ModalOverlay>
  );
};

export default HabitPackPdf;
